import { render } from "./SpecialtyModules.vue?vue&type=template&id=31b53208&scoped=true&lang=pug"
import script from "./SpecialtyModules.vue?vue&type=script&lang=js"
export * from "./SpecialtyModules.vue?vue&type=script&lang=js"

import "./SpecialtyModules.vue?vue&type=style&index=0&id=31b53208&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b53208"]])

export default __exports__